import { render, staticRenderFns } from "./SubmissionOfScientificWork.vue?vue&type=template&id=3ea24a6e&"
import script from "./SubmissionOfScientificWork.vue?vue&type=script&lang=js&"
export * from "./SubmissionOfScientificWork.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionOfScientificWork.vue?vue&type=style&index=0&id=3ea24a6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports